import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle"
export default class extends Controller {

  static targets = [ "results", "pane" ]

  connect() {
    this.search = debounce(this.search, 300)
    this.hide(null)
  }

  search = () => {
    let formData = new FormData(this.element)
    let q = formData.get("q")
    console.log("SEARCH", q)

    if (q.length >= 3) {
      this.element.requestSubmit()
      this.show()
    } else {
      this.hide();
    }
  }

  clean() {
    console.log("Clearing search results")
    this.resultsTarget.innerHTML = "<div class='text-center bg-white p-2'><i class='fa fa-spinner fa-spin'></div>"
  }

  show(){
    this.paneTarget.classList.remove("d-none")
  }

  hide(event){
    if (event && (this.element.contains(event.target))) {
      return;
    }
    this.paneTarget.classList.add("d-none")
    this.clean(); 
  }


}

const debounce = (fn, delay = 10) => {
  let timeoutId = null

  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(fn, delay)
  }
}


